// extracted by mini-css-extract-plugin
export default {"title":"InviteDiscountCard_title__ZLN8v","text":"InviteDiscountCard_text__yV8sx","details":"InviteDiscountCard_details__I4WtU"};